import { keepPreviousData } from '@tanstack/react-query';
import { array, ord, string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Enterprise, Order, useRepositoryQuery } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

export const getFilteredProperties = ({
    data,
    searchTerm,
    sortOrder,
}: {
    data: Enterprise[];
    searchTerm?: string;
    sortOrder?: Order;
}) => {
    const filteredData = searchTerm
        ? data.filter(({ name }) => name.toLowerCase().includes(searchTerm.toLowerCase()))
        : data;

    if (sortOrder == null) {
        return filteredData;
    }

    const orderByName: ord.Ord<Enterprise> = pipe(
        sortOrder === Order.Descending ? ord.reverse(string.Ord) : string.Ord,
        ord.contramap(({ name }) => name.toLowerCase())
    );
    return array.sortBy([orderByName])(filteredData);
};

export const usePropertiesUtils = ({
    assignedProperties,
    selectedRowsCount,
}: {
    assignedProperties: Enterprise[];
    selectedRowsCount: number;
}) => {
    const enterpriseId = useCurrentEnterpriseId();

    const { data } = useRepositoryQuery(
        'portfolioEnterpriseRelationships',
        'getAll',
        { pagination: { pageIndex: 0, pageSize: 1 }, enterpriseId },
        {
            placeholderData: keepPreviousData,
            select: (res) => res.totalRowCount,
        }
    );

    const totalPropertiesCount = data ?? 0;
    const isNoPropertyLeft = selectedRowsCount === assignedProperties.length || assignedProperties.length === 1;
    const areAllPropertiesAssigned = totalPropertiesCount === assignedProperties.length;

    return {
        isNoPropertyLeft,
        areAllPropertiesAssigned,
    };
};
